import { Handle, Position } from '@xyflow/react'
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { Box, Typography, useTheme } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';
import CloudCircleIcon from '@mui/icons-material/CloudCircle';
import { CustomTooltip } from '../../../../../components/TooltipCustomStyle';
import TooltipStatusTitle from '../../../../../components/TooltipStatusTitle';
import CheckHandleNodeEvent from '../../../../../utils/CheckHandleNodeEvent';

function RestfulApiNode(props) {
    const {
        data,
        selected,
    } = props;

    const theme = useTheme();

    return (
        <div
            className='rounded-sm min-w-[160px] h-12 relative'
        >
            <div className='flex overflow-hidden h-full'>
                <div className='bg-blue-600 rounded-tl-sm rounded-bl-sm justify-start items-center flex h-full px-2 cursor-pointer'>
                    <CloudCircleIcon color="white" sx={{ fontSize: 30 }} />
                </div>
                <div className={`bg-white w-full h-full rounded-tr-sm rounded-br-sm ${selected ? 'border border-blue-600' : 'border border-gray-300'} flex flex-col justify-center items-left px-3`}>
                    <div>
                        <Typography
                            variant='subtitle1'
                            fontSize={{
                                lg: 12,
                                md: 10,
                                sm: 10,
                                xs: 10
                            }}
                            sx={{
                                cursor: 'pointer',
                            }}
                        >
                            {data?.general_properties?.name?.client_name || 'Undifined'}
                        </Typography>
                    </div>
                    <div>
                        <Typography
                            variant="subtitle2"
                            fontSize={{
                                lg: 10,
                                md: 8,
                                sm: 8,
                                xs: 8
                            }}
                            sx={{
                                cursor: 'pointer',
                                color: 'GrayText',
                                maxWidth: 100,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                            }}
                        >
                            /{data?.general_properties?.prefix_path || ''}
                        </Typography>
                    </div>
                </div>
            </div>

            {(data?.general_properties?.name)
                &&
                <button
                    className="w-[18px] h-[18px] rounded-full bg-white hover:bg-gray-300 
                flex items-center justify-center 
                absolute right-[-10px] top-1/2 -translate-y-1/2 border border-gray-300"
                >
                    <MoreHorizIcon className="text-gray-700" sx={{ fontSize: 15 }} />
                </button>
            }

            {data?.error_text.length > 0 &&
                <div
                    style={{
                        position: 'absolute',
                        top: '-15px',
                        right: '5%',
                        transform: 'translate(-50%, 0)',
                        zIndex: 1000,
                        textAlign: 'center',
                    }}
                >
                    <CustomTooltip title={<TooltipStatusTitle headerTitle="Error" listDetails={data?.error_text} />} arrow placement="top" tooltipcolorstyle={theme.palette.error.main}>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: '50%',
                                background: '#fff',
                                width: 15,
                                height: 15,
                                marginTop: '5px'
                            }}
                        >
                            <ErrorIcon sx={{
                                color: theme.palette.error.main,
                                fontSize: 18,
                            }} />
                        </Box>
                    </CustomTooltip>
                </div>
            }

            <Handle
                id="top-target"
                type="target"
                position={Position.Top}
                style={CheckHandleNodeEvent(data, selected)}
            />
            <Handle
                id="left-target"
                type="target"
                position={Position.Left}
                style={CheckHandleNodeEvent(data, selected)}
            />
            <Handle
                id="bottom-target"
                type="target"
                position={Position.Bottom}
                style={CheckHandleNodeEvent(data, selected)}
            />
            <Handle
                position={Position.Right}
                type="source"
                style={{
                    background: 'transparent',
                    border: 'none',
                    width: '1px',
                    height: '1px',
                    pointerEvents: 'none'
                }}
            />
        </div>
    )
}

export default RestfulApiNode